import { render, staticRenderFns } from "./UiHeaderDropdown.vue?vue&type=template&id=f7d63642&scoped=true"
import script from "./UiHeaderDropdown.vue?vue&type=script&lang=js"
export * from "./UiHeaderDropdown.vue?vue&type=script&lang=js"
import style0 from "./UiHeaderDropdown.vue?vue&type=style&index=0&id=f7d63642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d63642",
  null
  
)

export default component.exports